export default "__VITE_ASSET__BImeuxSs__";